module.exports = __webpack_public_path__ + "static/media/linkedin.c1e965af.png";